import { render } from "./transaction-related.vue?vue&type=template&id=bc5c1df2&scoped=true"
import script from "./transaction-related.vue?vue&type=script&lang=js"
export * from "./transaction-related.vue?vue&type=script&lang=js"

import "./transaction-related.vue?vue&type=style&index=0&id=bc5c1df2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5c1df2"]])

export default __exports__